export const salesGraphsConstants = {
  SALES_GRAPHS_REQUEST: "SALES_GRAPHS_REQUEST",
  SALES_GRAPHS_SUCCESS: "SALES_GRAPHS_SUCCESS",
  SALES_GRAPHS_FAILURE: "SALES_GRAPHS_FAILURE",

  SALES_GRAPHS_DETAILS_REQUEST: "SALES_GRAPHS_DETAILS_REQUEST",
  SALES_GRAPHS_DETAILS_SUCCESS: "SALES_GRAPHS_DETAILS_SUCCESS",
  SALES_GRAPHS_DETAILS_FAILURE: "SALES_GRAPHS_DETAILS_FAILURE",

  SALES_GRAPHS_SEARCH_REQUEST: "SALES_GRAPHS_SEARCH_REQUEST",
  SALES_GRAPHS_SEARCH_SUCCESS: "SALES_GRAPHS_SEARCH_SUCCESS",
  SALES_GRAPHS_SEARCH_FAILURE: "SALES_GRAPHS_SEARCH_FAILURE"
};
